import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Site from "../models/Site";

export class SiteService extends GenericCrudServiceV2<Site> {
  readonly path: string;

  constructor(protected basePath: string) {
    super(basePath);
    this.path = basePath;
  }

  getFormData(site: Site): FormData {
    const formData = new FormData();

    formData.append("dto", JSON.stringify(site));

    return formData;
  }

  getSiteFilter(
    page: number,
    pageSize: number,
    projectExternalId: string,
    role: string,
    title: string,
    isArchived: boolean,
  ): Promise<ApiResponseV2<PagedResult<Site>>> {
    let query = `${this.basePath}/setup-all?page=${page}&pageSize=${pageSize}&projectExternalId=${projectExternalId}&role=${role}&title=${title}&isArchived=${isArchived}`;
    return HttpClientV2.get(query);
  }

  getByProjectAndRole(page: number, pageSize: number): Promise<ApiResponseV2<PagedResult<Site>>> {
    let query = `${this.basePath}/filter?page=${page}&pageSize=${pageSize}`;
    return HttpClientV2.get(query);
  }

  editSite(site: Site): Promise<ApiResponseV2<Site>> {
    return HttpClientV2.put(`${this.basePath}/update/${site.externalId}`, this.getFormData(site));
  }
}
export default new SiteService("/ensolvers-ops/user-sites");
